import AppContext from "PFApp/app_context";
import plannerEmptyStateUrl from "PFImages/premium/planner_empty_state.png";
import React, { useContext } from "react";

import PaginatedGanttChart from "../paginated_gantt_chart";
import { PlannerGantt } from "./planner_gantt";

export const Planner = () => {
  const {
    store: {
      pages: {
        workflowPage: {
          planner: { data, loading, setParams, noFiltersSelected, noOrderSelected }
        }
      }
    }
  } = useContext(AppContext);

  const plannerEmpty = !data || noFiltersSelected || noOrderSelected;

  return plannerEmpty ? (
    <img style={{ marginTop: 120, width: "100%" }} src={plannerEmptyStateUrl} alt="Planner" />
  ) : (
    <PaginatedGanttChart data={{ ...data, loading }} fetch={setParams} ganttComponent={PlannerGantt} />
  );
};
